import Send from '../send';

const DEFAULT_API = '/v1/site-info';

export default {

    siteInfoList() {
        return Send({
            url : `${DEFAULT_API}`,
            method : 'GET'
        });
    },

    siteInfoListBySeq(seq) {
        return Send({
            url : `${DEFAULT_API}/${seq}`,
            method : 'GET',
        });
    },

    updateSiteFileInfo(siteInfo) {
        return Send({
            url: `${DEFAULT_API}/file`,
            method: 'PUT',
            data: siteInfo
        });
    },

    updateSiteFooterInfo(seq, footer) {
        return Send({
            url : `${DEFAULT_API}/footer`,
            method : 'PUT',
            params : {
                seq : seq,
                footer : footer
            }
        });
    },

    createSiteInfo(seq, name) {
        return Send({
            url : `${DEFAULT_API}/createSiteInfo`,
            method : 'POST',
            params : {
                seq : seq,
                name : name
            }
        });
    },

    updateSiteInfo(seq, name) {
        return Send({
            url : `${DEFAULT_API}/updateSiteInfo`,
            method : 'PUT',
            params : {
                seq : seq,
                name : name
            }
        });
    },

    deleteSiteInfo(seq) {
        return Send({
            url : `${DEFAULT_API}/deleteSiteInfo`,
            method : 'DELETE',
            params : {
                seq : seq
            }
        });
    },

    getSiteVisitPurposeInfo(siteInfoSeq) {
        return Send({
            url : `${DEFAULT_API}/visit-purpose`,
            method : 'GET',
            params : {
                siteInfoSeq : siteInfoSeq
            }
        });
    },

    createSiteVisitPurposeInfo(siteInfoSeq, name) {
        return Send({
            url : `${DEFAULT_API}/visit-purpose`,
            method : 'POST',
            params : {
                siteInfoSeq : siteInfoSeq,
                name : name
            }
        });
    },

    updateSiteVisitPurposeInfo(siteVisitPurposeInfoSeq, name) {
        return Send({
            url : `${DEFAULT_API}/visit-purpose`,
            method : 'PUT',
            params : {
                seq : siteVisitPurposeInfoSeq,
                name : name
            }
        });
    },

    deleteSiteVisitPurposeInfo(siteVisitPurposeInfoSeq) {
        return Send({
            url : `${DEFAULT_API}/visit-purpose-group`,
            method : 'DELETE',
            params : {
                seq : siteVisitPurposeInfoSeq
            }
        });
    },

    getSiteVisitPurposeGroupInfo(siteInfoSeq) {
        return Send({
            url : `${DEFAULT_API}/visit-purpose-group`,
            method : 'GET',
            params : {
                siteInfoSeq : siteInfoSeq,
            }
        });
    },

    createSiteVisitPurposeGroupInfo(siteInfoSeq, name) {
        return Send({
            url : `${DEFAULT_API}/visit-purpose-group`,
            method : 'POST',
            params : {
                siteInfoSeq : siteInfoSeq,
                name : name
            }
        });
    },

    updateSiteVisitPurposeGroupInfo(seq, name, siteVisitPurposeInfos) {
        return Send({
            url : `${DEFAULT_API}/visit-purpose-group`,
            method : 'PUT',
            params : {
                seq : seq,
                name : name,
                siteVisitPurposeInfos : siteVisitPurposeInfos
            }
        });
    },

    deleteSiteVisitPurposeGroupInfo(seq) {
        return Send({
            url : `${DEFAULT_API}/visit-purpose-group`,
            method : 'DELETE',
            params : {
                seq : seq
            }
        });
    },

}
